<hr />
<div class="d-flex justify-content-between row-data mt-3 mb-3">
  <ng-content></ng-content>
</div>
